import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { API_URL, isManager } from '../components/pendencias/pendShared';
import { PendCard } from '../components/pendencias/PendCard';
import { PendNoteDialog } from '../components/pendencias/PendNoteDialog';
import { SituacoesTab } from '../components/pendencias/SituacoesTab';
import { Nova72hTab } from '../components/pendencias/Nova72hTab';

const GROUPS = [
  { key: 'curso', label: 'Em curso (24h)', match: (s) => ['enviado', 'lido'].includes(s) },
  { key: 'urgente', label: 'Pendentes de resolução', match: (s) => ['pendente_resolucao', 'em_atraso'].includes(s) },
  { key: 'concluidas', label: 'Concluídas', match: (s) => s === 'concluido' },
];

export default function PendenciasPage() {
  const { user } = useAuth();
  const manager = isManager(user);
  const [rows, setRows] = useState([]);
  const [dlg, setDlg] = useState({ pend: null, mode: null });
  const load = useCallback(async () => {
    try { const { data } = await axios.get(`${API_URL}/pendencias`); setRows(data); } catch { setRows([]); }
  }, []);
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, [load]);

  return (
    <Layout>
      <div className="space-y-5" data-testid="pendencias-page">
        <div>
          <h1 className="text-3xl sm:text-4xl font-bold font-[Outfit] text-[#2D3E6F]">Pendentes por resolver</h1>
          <p className="text-sm text-slate-500 mt-1">
            {manager ? 'Alerte os comerciais sobre clientes que precisam de ação e acompanhe as respostas.' : 'Alertas do gestor: dê como lido e trate em 24h. O que não ficar resolvido passa a pendente urgente.'}
          </p>
        </div>
        <Tabs defaultValue={new URLSearchParams(window.location.search).get('tab') || (manager ? 'situacoes' : 'curso')}>
          <TabsList className="flex-wrap h-auto">
            {manager && <TabsTrigger value="situacoes" data-testid="pend-tab-situacoes">Por alertar</TabsTrigger>}
            {manager && <TabsTrigger value="nova72" data-testid="pend-tab-nova72">Leads em Nova +72h</TabsTrigger>}
            {GROUPS.map((g) => (
              <TabsTrigger key={g.key} value={g.key} data-testid={`pend-tab-${g.key}`}>
                {g.label} ({rows.filter((r) => g.match(r.status)).length})
              </TabsTrigger>
            ))}
          </TabsList>
          {manager && <TabsContent value="situacoes"><SituacoesTab onSent={load} /></TabsContent>}
          {manager && <TabsContent value="nova72"><Nova72hTab /></TabsContent>}
          {GROUPS.map((g) => {
            const list = rows.filter((r) => g.match(r.status));
            return (
              <TabsContent key={g.key} value={g.key} className="space-y-3">
                {list.length === 0 && <div className="text-sm text-slate-400 py-8 text-center">Nada aqui.</div>}
                {list.map((p) => (
                  <PendCard key={p.id} p={p} manager={manager} mine={p.recipient_id === user?.id}
                    onAction={(pend, mode) => setDlg({ pend, mode })} onChanged={load} />
                ))}
              </TabsContent>
            );
          })}
        </Tabs>
      </div>
      <PendNoteDialog pend={dlg.pend} mode={dlg.mode} onClose={() => setDlg({ pend: null, mode: null })} onDone={load} />
    </Layout>
  );
}
